"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var Text_1 = __importDefault(require("shared/components/Text"));
var MentionAvatar_1 = __importDefault(require("./MentionAvatar"));
var EntryWrapper = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        padding: '7px 10px 3px 10px',
        '.MuiAvatar-root.MuiAvatar-circle': {
            margin: 4,
            marginLeft: 3,
        },
        ':hover, &[aria-selected="true"]': {
            backgroundColor: theme.palette.secondary.light,
        },
    });
});
var Entry = function (_a) {
    var mention = _a.mention, theme = _a.theme, parentProps = __rest(_a, ["mention", "theme"]);
    return ((0, jsx_runtime_1.jsxs)(EntryWrapper, __assign({}, parentProps, { children: [(0, jsx_runtime_1.jsx)(MentionAvatar_1.default, { mention: mention }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, ml: 1 }, { children: mention.name }))] })));
};
exports.default = Entry;
